import React from 'react';

import { colors } from 'helpers/ColorHelper';

import { localize } from 'react-localize-redux';

const statusMap = {
  Paid: { color: colors.GREEN, text: 'paid' },
  Pending: { color: colors.YELLOW, text: 'pending' },
  Autopay: { color: colors.GREEN, text: 'autopay' },
  Waived: { color: colors.GREEN, text: 'waived' },
  'Pending eTransfer': { color: colors.YELLOW, text: 'pendingETransfer' },
  'Post Dated Cheques': { color: colors.YELLOW, text: 'postDatedCheques' },
  'Pre-Auth Debit': { color: colors.YELLOW, text: 'preAuthDebit' },
  Late: { color: colors.RED, text: 'late' },
  'NSF Fee': { color: colors.RED, text: 'NSF' },
};

export const statusMapper = status => {
  return statusMap[status] || { color: colors.YELLOW, text: 'pending' };
};

// Deprecated - use the PaymentStatus function in StatusHelper
let PaymentStatus = props => {
  const statusItem = statusMapper(props.status);

  return (
    <span>
      <span style={{ color: statusItem.color, transition: 'all .3s ease' }}>&#x25cf;</span> {' '}
      {props.translate(`transactions.status.${statusItem.text}`)}
    </span>
  );
};

export default localize()(PaymentStatus);
